// extracted by mini-css-extract-plugin
module.exports = {"theme":"#3baf61"};